// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locations-picker {
  position: relative;
  height: 40px;
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
}
.locations-picker .select-place-holder {
  color: #605260;
  font-size: 13px;
  margin-left: 9px;
  max-width: 24rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.locations-picker .dropdown-toggle {
  line-height: 40px;
}
.locations-picker .dropdown-toggle .arrow {
  line-height: 40px;
  font-size: 14px;
  color: #5e0066;
  margin-right: 9px;
  margin-left: auto;
}
.locations-picker .location-dropdown-menu {
  position: absolute;
  z-index: 100;
  width: 100%;
  max-width: 100%;
  background-color: #FFFFFF;
  margin: -3px 0;
  padding: 0;
  border-radius: 0px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-top: 2px solid #29BB73;
  max-height: 200px;
  overflow-y: auto;
}
.locations-picker .location-dropdown-menu span.icon-edit {
  float: right;
  color: #490050;
  font-size: 20px;
  cursor: pointer;
}
.locations-picker .location-dropdown-menu hr {
  margin: 0;
}
.locations-picker .location-dropdown-menu > div {
  padding: 0px 9px;
}
.locations-picker .location-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}
.locations-picker .location-dropdown-menu::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.locations-picker .location-dropdown-menu::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.5);
}
.locations-picker .element-hightlight:hover {
  background-color: rgba(41, 187, 115, 0.1);
}
.locations-picker .location-box {
  display: flex;
  align-items: center;
  height: 40px;
  cursor: pointer;
  margin: 0;
}
.locations-picker .location-box span {
  margin-left: 10px;
}

.invalid {
  border-color: red;
}`, "",{"version":3,"sources":["webpack://./src/app/components/filming-location/filming-form/filming-form-item/filming-form-item.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AACF;AAIE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFJ;AAKE;EACE,iBAAA;AAHJ;AAKI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAHN;AAOE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,qCAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;AALJ;AAOI;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AALN;AAQI;EACE,SAAA;AANN;AASI;EACE,gBAAA;AAPN;AAUI;EACE,UAAA;AARN;AAWI;EACE,oDAAA;EACA,kBAAA;AATN;AAYI;EACE,kBAAA;EACA,oDAAA;AAVN;AAcE;EACE,yCAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;AAbJ;AAeI;EACE,iBAAA;AAbN;;AAkBA;EACE,iBAAA;AAfF","sourcesContent":[".locations-picker {\n  position: relative;\n  height: 40px;\n  border: 1px solid #EBE9EB;\n  border-radius: 3px;\n  background-color: #FCFCFC; // cursor: pointer;\n  @media (min-width: 768px) {\n    // width: 446px;\n  }\n\n  .select-place-holder {\n    color: #605260;\n    font-size: 13px;\n    margin-left: 9px;\n    max-width: 24rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .dropdown-toggle {\n    line-height: 40px;\n\n    .arrow {\n      line-height: 40px;\n      font-size: 14px;\n      color: #5e0066;\n      margin-right: 9px;\n      margin-left: auto;\n    }\n  }\n\n  .location-dropdown-menu {\n    position: absolute;\n    z-index: 100;\n    width: 100%;\n    max-width: 100%;\n    background-color: #FFFFFF;\n    margin: -3px 0;\n    padding: 0;\n    border-radius: 0px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-top: 2px solid #29BB73;\n    max-height: 200px;\n    overflow-y: auto;\n\n    span.icon-edit {\n      float: right;\n      color: #490050;\n      font-size: 20px;\n      cursor: pointer;\n    }\n\n    hr {\n      margin: 0;\n    }\n\n    &>div {\n      padding: 0px 9px;\n    }\n\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);\n      border-radius: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      border-radius: 4px;\n      -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.5);\n    }\n  }\n\n  .element-hightlight:hover {\n    background-color: rgba(41, 187, 115, 0.1)\n  }\n\n  .location-box {\n    display: flex;\n    align-items: center;\n    height: 40px;\n    cursor: pointer;\n    margin: 0;\n\n    span {\n      margin-left: 10px;\n    }\n  }\n}\n\n.invalid {\n  border-color: red;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
